import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2AssignResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function assignIndirectTaxFilingV2User({
  filingId,
  userId,
  corporationId,
  token,
}: {
  filingId: string;
  userId: string;
  corporationId: number;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2AssignResponse>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}/assign-user/${userId}?corporationId=${corporationId}`,
      { method: 'POST' },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to assign user to filing',
      };
    }
    const data: IIndirectTaxFilingV2AssignResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to assign user to filing',
    };
  }
}
